import { SvgIcon, SvgIconProps } from '@mui/material';

const CardsStarIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" fill="none">
      <mask
        id="mask0_2006_87"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <rect width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2006_87)">
        <path
          d="M20.0699 21.1387L23.8616 18.8471L27.6532 21.1387L26.6532 16.8054L29.9866 13.9304L25.6116 13.5554L23.8616 9.47208L22.1116 13.5554L17.7366 13.9304L21.0699 16.8054L20.0699 21.1387ZM9.08366 36.5696C8.31505 36.6712 7.62755 36.4929 7.02116 36.0346C6.41477 35.5763 6.06519 34.9629 5.97241 34.1946L3.45866 14.2917C3.36616 13.5231 3.5513 12.8332 4.01408 12.2221C4.47713 11.611 5.09297 11.2592 5.86158 11.1667L8.27824 10.8887V26.1667C8.27824 27.7036 8.81519 29.0137 9.88908 30.0971C10.9632 31.1804 12.2688 31.7221 13.8057 31.7221H32.5557C32.5002 32.3149 32.2781 32.8265 31.8895 33.2571C31.5006 33.6876 31.0006 33.9353 30.3895 34L9.08366 36.5696ZM13.8337 28.9446C13.0837 28.9446 12.4332 28.669 11.8824 28.1179C11.3313 27.5671 11.0557 26.9167 11.0557 26.1667V6.11124C11.0557 5.36124 11.3313 4.71069 11.8824 4.15958C12.4332 3.60875 13.0837 3.33333 13.8337 3.33333H33.8891C34.6391 3.33333 35.2896 3.60875 35.8407 4.15958C36.3916 4.71069 36.667 5.36124 36.667 6.11124V26.1667C36.667 26.9167 36.3916 27.5671 35.8407 28.1179C35.2896 28.669 34.6391 28.9446 33.8891 28.9446H13.8337Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default CardsStarIcon;
